export const TABS = {
  BASIC: 'basic',
  LOGIC: 'logic'
};